import State from 'webutils/services/state'

export default [
    new State("AB", "Alberta"),
    new State("BC", "British Columbia"),
    new State("MB", "Manitoba"),
    new State("NB", "New Brunswick"),
    new State("NL", "Newfoundland and Labrador"),
    new State("NS", "Nova Scotia"),
    new State("ON", "Ontario"),
    new State("PE", "Prince Edward Island"),
    new State("QC", "Quebec"),
    new State("SK", "Saskatchewan"),
    new State("NT", "Northwest Territories"),
    new State("NU", "Nunavut"),
    new State("YT", "Yukon")
];